import { window } from '../../helpers/BrowserHelpers';
export default function getRangeRect(editor, range) {
  if (!range) {
    return undefined;
  }

  var domRange = editor.findDOMRange(range, window);

  if (range.isCollapsed) {
    return domRange ? domRange.getClientRects().item(0) : undefined;
  } else {
    return domRange ? domRange.getBoundingClientRect() : undefined;
  }
}